import { render, staticRenderFns } from "./AvatarsStoreFilter.vue?vue&type=template&id=08f8be42&"
import script from "./AvatarsStoreFilter.vue?vue&type=script&lang=js&"
export * from "./AvatarsStoreFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports